import PropTypes from 'prop-types';
import React, { Component } from 'react';

import {StandardPage} from "../../Common/pages/StandardPage";
import {RightColumn} from "../../Common/pages/RightColumn";

export default class GreyhoundRacingResults extends Component {
  static propTypes = {
    GreyhoundRacingResultsForDateContainer: PropTypes.element.isRequired,
    location: PropTypes.object.isRequired,
  };

  render() {
    const {
      location,
      GreyhoundRacingResultsForDateContainer,
    } = this.props;

    return (
      <div className="GreyhoundRacingResults">
        <StandardPage sport="greyhounds" title="Greyhounds results">
          <div className="main-layout-left-column">
            {GreyhoundRacingResultsForDateContainer}
          </div>

          <RightColumn location={location}
                       sport="greyhounds"
                       content={
                         ["topMpu", "ocWidget", "racingTips", "bottomMpu", "horseRacingNextRaceOff", "footballTips"]} />
        </StandardPage>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./modules/GreyhoundRacing/containers/GreyhoundRacingResults.js